import $ from 'jquery';
import { validationOptions } from '../../../constants/options';
import { validateEmail } from '../../../components/validations';
import { toggleButtonLoader } from '../../../utils/button-loader';
export default class RegistrationChangeEmail {
    static $form;
    static errors;
    static init() {
        if ($('.js__registration-change-email-form').length) {
            this.$form = $('.js__registration-change-email-form');
            this.errors = $('.js__form-error-translations').data('errors');
            this.bindEvents();
        }
    }
    static bindEvents() {
        this.$form.validate({
            ...validationOptions,
            onkeyup: element => {
                if ($(element).hasClass('js__registration-email-change-input')) {
                    return false;
                }
                $(element).valid();
            },
            onfocusout: element => {
                $(element).valid();
            },
            invalidHandler: (evt, error) => {
                $.each(error.errorList, (index, item) => {
                    // @ts-ignore
                    const message = item.method ? $(item.element).data(`${item.method}Error`) : item.message;
                    window.dataLayer.push({
                        event: 'systemError',
                        errorType: 'form registration change email',
                        errorMessage: message,
                    });
                });
            },
        });
        this.bindValidations();
        $('.js__registration-change-email-submit').on('click', e => {
            e.preventDefault();
            if (this.$form.valid() && !this.$form.find('.pending').length) {
                toggleButtonLoader($(e.currentTarget), true);
                this.$form.trigger('submit');
            }
        });
    }
    static bindValidations() {
        validateEmail(this.$form.find('.js__registration-email-change-input'), this.$form, this.errors, String(this.$form.find('.js__registration-email-change-input').val()));
    }
}
